import React from 'react';
import styled from 'styled-components';

import { mediaQueryLaptopMin, mediaQueryDesktopMin, colorWhite } from 'styles';

const Wrapper = styled(({ hideOnMobile, sticky, ...props }) => (
  <section {...props} />
))`
  background-color: ${colorWhite};
  border-radius: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.14);
  padding: 16px;
  margin-bottom: 16px;
  width: 100%;

  @media all and ${mediaQueryDesktopMin} {
    padding: 24px;
  }

  ${({ hideOnMobile }) => {
    if (hideOnMobile) {
      return `
        display: none;

        @media all and ${mediaQueryLaptopMin} {
          display: block;
        }
      `;
    }

    return '';
  }}

  ${({ sticky }) => {
    if (sticky) {
      return `
        position: sticky;
        top: 16px;
      `;
    }

    return '';
  }}
`;

export default Wrapper;
